/**
 * @generated SignedSource<<fca745311578f3101b6fa0e65717a6fb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraVersion$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraVersion";
};
export type moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraVersion$key = {
  readonly " $data"?: moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraVersion$data;
  readonly " $fragmentSpreads": FragmentRefs<"moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraVersion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraVersion",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "name"
      },
      "action": "THROW",
      "path": "name"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "84a88afd5bdd1daa65b86ea3c2e3ac4e";

export default node;
